(function (angular) {
    angular.module('bizPartEngage').directive('bizMyNotes', bizMyNotes);
    angular.module('bizPartEngage').controller('biz.my.notes.edit.dialog', bizMyNotesEditDialogController);

    bizMyNotes.$inject = ["bizCore", "core.users.service"];
    bizMyNotesEditDialogController.$inject = ["$mdDialog", "bizMediabankService", "bizCoreService", "core.mynotes.service", "$q", "$translate"];

    function bizMyNotes(bizCore, userService) {
        var directive = {
            restrict: "E",
            scope: {
                limit: '@',
                limitDateFrom: '=?',
                limitDateTo: '=?'
            },
            templateUrl: bizCore.getView('core.directives.mynotes', "FrontEnd/Core/Directives/Views/MyNotes.html"),
            bindToController: true,
            controller: bizMyNotesController,
            controllerAs: "vm"
        }

        bizMyNotesController.$inject = ['$mdDialog', 'core.mynotes.service'];

        function bizMyNotesController($mdDialog, myNotesService) {
            var vm = this;
            vm.Notes = [];

            vm.EditMyNotesDialog = EditMyNotesDialog;
            vm.GetMyNotes = GetMyNotes;

            function EditMyNotesDialog() {
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: siteRootPath + "FrontEnd/Core/Directives/Views/MyNotesEditDialog.html",
                    controller: 'biz.my.notes.edit.dialog',
                    controllerAs: "vm",
                    bindToController: true,
                    locals: {
                        limit: vm.limit,
                        fromDate: vm.limitDateFrom,                        
                        toDate: vm.limitDateTo,
                        notes: angular.copy(vm.Notes),
                        data: angular.copy(vm.Data)
                    }
                }).then(EditClose);

                function EditClose(data) {
                    vm.GetMyNotes();
                    if (data) {
                        vm.Data = data;
                    }
                }
            }

            function GetMyNotes() {
                
                var from = BizPartCoreHelpers.getDateNow().subtract(100, 'days').toDate();
                var to = BizPartCoreHelpers.getDateNow().add(100, 'days').toDate();

                if (vm.limitDateFrom) {                    
                    from = moment(vm.limitDateFrom).toDate();
                }

                if (vm.limitDateTo) {                    
                    to = moment(vm.limitDateTo).toDate();
                }

                var limit = 4;
                if (vm.limit) {
                    limit = ~~vm.limit;
                }                

                myNotesService.GetMyNotes(limit, from, to).then(GetMyNotesSuccess);
                function GetMyNotesSuccess(response) {
                    vm.Notes = response.data;
                }
            }

            function Init() {
                vm.GetMyNotes();
                userService.GetLoggedInUserSetting("MY_NOTES").then(GetSettingCallback);

                function GetSettingCallback(response) {
                    var data = BizPartCoreHelpers.getResponseValue(response);
                    if (data) {
                        vm.Data = JSON.parse(data);
                    } else {
                        vm.Data = {
                            ImageUrl: "https://qeeptest.bizpart.com/Upload/5/Mediabank/Files/39210552-2472-4021-8ac8-06b0e9b59d0f.jpg",
                            Color: "#FFF"
                        };
                    }
                }
            }

            vm.$onInit = Init;
        }

        return directive;
    }

    function bizMyNotesEditDialogController($mdDialog, bizMediabankService, bizCoreService, myNotesService, $q, $translate) {
        var vm = this;

        vm.AddNote = AddNote;
        vm.Save = Save;
        vm.Close = Close;
        vm.SelectImage = SelectImage;        

        //todo: fix some general color translations
        vm.Colors = [
            {
                Name: 'Svart',
                Id: '#000'
            },
            {
                Name: 'Vit',
                Id: '#FFF'
            }
        ];

        function AddNote() {
            var note = {
                Id: 0,
                Text: ""
            };

            vm.notes.unshift(note);
        }

        function Save() {
            vm.data.ImageUrl = vm.image ? vm.image.FileUrl : undefined;
            vm.data.Color = vm.selectedColor.Id;
            $q.all([
                bizCoreService.UpdateUserSetting("MY_NOTES", JSON.stringify(vm.data)),
                myNotesService.SaveMyNotes(vm.notes)
            ])
            .then(function (response) {
                myNotesService.ClearPromiseCache();
                $mdDialog.hide(vm.data);
            });  
        }

        function Close(data) {
            $mdDialog.hide(data);
        }

        function SelectImage() {
            bizMediabankService.ShowMediabankDialog(vm.image, null, vm.uploadSettings).then(ShowMediabankDialogCallback);

            function ShowMediabankDialogCallback(file) {
                if (!file)
                    return;
                vm.image = file;
            }
        }            

        

        vm.$onInit = function () {                        
            vm.selectedColor = vm.Colors.GetItemByValue('Id', vm.data.Color);
            vm.image = {
                FileUrl: vm.data.ImageUrl
            };

            vm.uploadSettings = {
                FileType: bizMediabankService.FileTypes.Image,
                FileLocation: bizMediabankService.UploadLocations.MyText,
                FilePattern: '',
                IsPrivate: true,
                IsInvisible: false,
                IsPrivateControlHidden: true,
                IsInvisibleControlHidden: true,
                IsUser: true
            };    

            $translate('BIZMYNOTES_EDIT_NOTE_HEADER').then(function (translation) {                
                var header = translation.toString();                
                header = header.replace('##FROM##', moment(vm.fromDate).format('DD MMMM'));
                header = header.replace('##TO##', moment(vm.toDate).format('DD MMMM'));
                vm.header = header;
            });
        }
    }

})(window.angular);
